// Change badges of Admin Analytics → Deflect (DAA-2-20 … DAA-2-22). No imports, so the Node test
// runner can load it: `node --test src/Containers/AdminDeflectAnalyticsPage/utils/__tests__`.

export const CHANGE_TONE = {
  GOOD: "good",
  BAD: "bad",
  NEUTRAL: "neutral"
}

// Which way a metric is good: up (lookups, revenue), down (lookups without merchant, days to
// Active) or neither (Call center share).
export const GOOD_DIRECTION = {
  UP: "up",
  DOWN: "down",
  NEUTRAL: "neutral"
}

// A change is shown to one decimal; one that rounds to 0.0 (under 0.05) reads as no change. The
// nudge keeps a float like 50.05 − 50 = 0.04999… on the 0.1 side, where it belongs.
const toTenths = (delta) => Math.round((delta + Math.sign(delta) * 1e-9) * 10) / 10

const MINUS = "−"

const toneOf = (delta, goodDirection) => {
  if (goodDirection === GOOD_DIRECTION.NEUTRAL) return CHANGE_TONE.NEUTRAL

  const isUp = delta > 0
  const isGood = goodDirection === GOOD_DIRECTION.UP ? isUp : !isUp

  return isGood ? CHANGE_TONE.GOOD : CHANGE_TONE.BAD
}

// "+1,234.5%"
const signed = (delta, unit) => {
  const sign = delta > 0 ? "+" : MINUS
  const figure = Math.abs(delta).toLocaleString("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })

  return `${sign}${figure}${unit}`
}

const noChange = (text) => ({ text, tone: CHANGE_TONE.NEUTRAL, direction: null })

// The badge of a count or an amount: change in percent of the comparison value (DAA-2-20).
// A figure with nothing to compare against, or that could not be computed, reads "n/a".
export const getPercentChange = (value, comparison, goodDirection = GOOD_DIRECTION.UP) => {
  if (!Number.isFinite(value) || !Number.isFinite(comparison) || comparison === 0)
    return noChange("n/a")

  // Against the size of the comparison value, so a negative one does not flip the direction.
  const delta = toTenths(((value - comparison) / Math.abs(comparison)) * 100)

  if (delta === 0) return noChange("0%")

  return {
    text: signed(delta, "%"),
    tone: toneOf(delta, goodDirection),
    direction: delta > 0 ? "up" : "down"
  }
}

// The badge of a share: change in percentage points (DAA-2-21). A share with no denominator on
// either side reads "n/a" (DAA-2-26).
export const getPointChange = (value, comparison, goodDirection = GOOD_DIRECTION.UP) => {
  if (!Number.isFinite(value) || !Number.isFinite(comparison)) return noChange("n/a")

  const delta = toTenths(value - comparison)

  if (delta === 0) return noChange("0 pp")

  return {
    text: signed(delta, " pp"),
    tone: toneOf(delta, goodDirection),
    direction: delta > 0 ? "up" : "down"
  }
}
